import { axiosWithToken } from '../../../utils/axios';

type postSearchLogProps = {
  word: string;
  client_id: string;
};

const postSearchWord = async (props: postSearchLogProps) => {
  try {
    const data = {
      word: props.word,
      client_id: props.client_id,
    }
    const response = await axiosWithToken.post(`/searchword/`, {data, isToken:true});

    return response.data;
  } catch (error) {
    // エラーが発生した場合の処理
  }
};

export default postSearchWord;
